import Hero7TageBodyBoost from '../components/Hero7TageBodyBoost';
import Problem from '../components/Problem';
import Results from '../components/Results';
import Impact from '../components/Impact';
import Value from '../components/Value';
import TestimonialSlider from '../components/TestimonialSlider';
import FAQ from '../components/FAQ';
import Closing from '../components/Closing';
import FloatingCTA from '../components/FloatingCTA';
import Footer from '../components/Footer';

export default function Home7TageBodyBoost() {
  return (
    <>
      <Hero7TageBodyBoost />
      <Problem />
      <Results />
      <Impact />
      <Value />
      <TestimonialSlider />
      <FAQ />
      <Closing />
      <FloatingCTA />
      <Footer showAdvertorialDisclaimer={true} />
    </>
  );
}
